<template>
  <div class="light filter-input">
    <input
      class="filter-input__field"
      v-model="localValue"
      @keydown.enter.prevent="onEnterKey"
      enterkeyhint="search"
      :placeholder="i18n.t('exchange-form.drop-down.search')"
      v-bind="$attrs"
    >
    <span v-if="localValue" class="filter-input__close" @click="onReset">
      <IconClose />
    </span>
  </div>
</template>

<!-- Replace with defineOptions after migrate to vue 3 -->
<script lang="ts">
export default {
  inheritAttrs: false
}
</script>

<script lang="ts" setup>
import { computed } from 'vue';
import IconClose from '../../../assets/images/exchange-form/close.svg';

import { i18n } from '@kano/i18n';

const props = defineProps<{
  value: string,
}>();

const emit = defineEmits<{
  (event: 'input', value: string): void,
}>();

const localValue = computed({
  get: () => props.value,
  set: (value: string) => emit('input', value),
});

function onReset() {
  emit('input', '');
}

// Prevent the mobile keyboard action key ("Next" on Android) from moving
// focus out of the dropdown; blur instead to dismiss the keyboard.
function onEnterKey(event: KeyboardEvent) {
  (event.target as HTMLInputElement).blur();
}
</script>

<style lang="scss" scoped>
@use '@kanoAssets/styles/breakpoints.scss';

.filter-input {
  margin-bottom: 34px;
  position: relative;

  @include breakpoints.desktop {
    margin-bottom: 20px;
  }

  &__field {
    font-size: 16px;
    font-weight: 400;
    background: var(--color-base-0);
    border-bottom: 1px solid rgba(0, 0, 0, 0.08);
    padding-left: 24px;
    padding-right: 24px;
    width: 100%;
    outline: none;
    height: 36px;
    transition: border-color 0.2s ease-in-out;

    ::placeholder {
      font-size: 16px;
      line-height: 19px;
      color: var(--color-base-48);
    }

    &:focus {
      border-color: var(--color-primary);
    }
  }

  &__close {
    position: absolute;
    right: 28px;
    top: 10px;
    cursor: pointer;
  }
}
</style>
